import { useContext } from 'react';
import ContentEmbedContext from 'context/contentEmbed';

const useContentEmbed = () => useContext(ContentEmbedContext);

export default useContentEmbed;
